export const AppConstants = {
    app_version: '2.10',
    app_release_date: 'January 10 2024',
};
